<template lang="pug">
v-container(fluid)
  v-progress-linear(v-if="loading" indeterminate, rounded, height="6")
  template(v-else)
    v-row(v-if="is_active")
      v-col(cols="12")
        h1 Обращения
      v-col(cols="12")
        v-card(outlined)
          v-tabs(v-model="tab" background-color="transparent"  show-arrows)
            //- Не выводить все.
            v-tab(v-for="table in tabList" :key="table.value" :href="`#${table.value}`") {{table.text}}
              v-badge(inline :content="table.count" small).ml-2
            v-divider.mb-2
            v-tabs-items(v-model="tab")
              v-tab-item(
                v-for="table in tabList" :key="table.value"
                v-if="table.value.toString() === tab"
                :value="`${table.value}`"
                )
                smart-table(
                  v-model="selected"
                  :adapter="adapter"
                  :headers="headers"
                  :needToUpdateTable="needToUpdateTable"
                  :sorting="{ id: 'ASC' }"
                  show-select
                  :row-class="checkIsOverdue"
                  storageSaveProject
                  :noDataText="isSupport || isAdmin ? 'Вы большие молодцы, котики! Можете немножко отдохнуть до следующего обращения' : 'Записи не найдены'"
                )
                  template(#value--created_at="{ item }")
                    | {{ item.created_at | readableDateTime }}
                  template(#header)
                    app-dropdown(
                      v-if="!selected.length && tab === CLIENT_QUESTION_STATUS.AWAITING.toString()"
                      v-model="consultingType"
                      :items="consultingDropdownFilter"
                      toggleComponent="v-chip"
                      color="primary"
                      classSpan="d-block align-self-center"
                    )

                    template(v-if="selected.length")

                      v-btn.rounded.mr-2(color="accent") Выбрано: {{ selected.length }}
                      v-btn.mr-2(color="primary" @click="dialogEventForm = true") Объединить
                      v-btn.mr-2(color="success" @click="groupClose" v-if="checkStatus(false, 4)") Закрыть
                      v-btn.mr-2.rounded(
                        @click="deleteQuestionsDialog = true"
                        color="error"
                        fab
                        small
                        tile
                        height="36px"
                      )
                        v-icon(small) mdi-trash-can
                      v-btn.mr-2.rounded(@click="selected = []" text fab small tile height="36px")
                        v-icon mdi-close
                  template(#search--status="{ searchKeys, runSearch}")
                    v-select(
                      v-model="searchKeys.status"
                      placeholder="Статус"
                      prepend-inner-icon="mdi-magnify"
                      outlined
                      :items="statusItems"
                      @input="runSearch"
                      hide-details
                      dense
                      clearable
                    )
                  template(#search--project_id="{ searchKeys, runSearch}")
                    select-project(
                      v-model="searchKeys.project_id"
                      placeholder="Проект"
                      prepend-inner-icon="mdi-magnify"
                      outlined
                      multiple
                      hide-details
                      dense
                      clearable
                      @input="runSearch"
                    )
                  template(#search--worker="{ searchKeys, runSearch}")
                    select-my-user(
                      v-model="searchKeys.worker_id"
                      hide-details
                      dense outlined
                      :query="{ 'search[parent_id]': user.parent_id || user.id }"
                      @input="runSearch"
                    )
                  template(#value--groups="{ item }")
                    v-menu(
                      open-on-hover
                      bottom
                      offset-y
                      v-if="item.groups.length"
                    )
                      template(v-slot:activator="{ on }")
                        v-btn(color="primary" v-on="on" small)
                          | {{ item.groups[0].title }}
                          | {{ item.groups.length > 1 ? '...' : ''}}
                      v-list
                        v-list-item(v-for="group in item.groups" :key="group.id")
                          v-list-item-title {{group.title}}
                    template(v-else)
                      p
                  template(#value--todo_lists_status="{ item }")
                    .d-flex.align-center.flex-column.mt-2(
                      v-if="item.todo_lists_status && item.status !== CLIENT_QUESTION_STATUS.PENDING && item.todo_lists_status.total"
                    )
                      v-progress-circular(
                        :size="30"
                        :width="7"
                        :value="item.todo_lists_status.complete / item.todo_lists_status.total * 100"
                        color="accent"
                      )
                      span {{ item.todo_lists_status.complete }} из {{ item.todo_lists_status.total }}
                    .d-flex.align-center.flex-column.mt-2(v-else) -
                  template(#value--question_category_name="{ item }")
                    v-chip(
                      small
                      label
                    ) {{ cachedCategory(item.question_category_id).name || item.question_category_name }}
                  template(#value--worker="{ item }")
                    v-chip(
                      small
                      color="accent"
                      label
                    ) {{ item.worker.username }}
                  template(#value--project_id="{ item }")
                    v-chip(
                      small
                      color="secondary"
                      label
                    ) {{ cachedProject(item.project_id).name }}
                  template(#value--municipality_id="{ item }")
                    v-chip(v-if="item.municipality_id" text label small)
                      | {{ cachedMunicipality(item.municipality_id).name }}
                  template(#value--view="{ item }")
                    router-link(:to="`/application/${item.id}`")
                      v-icon(color="primary" small) mdi-eye
                  template(#value--status="{ item }")

                    v-chip(small label :color="statusColor(item.status)")
                      template(v-if="isConsultating(item)") Ожидает консультации
                      template(v-else) {{ CLIENT_QUESTION_STATUS_TEXT[item.status] }}
    v-alert(type="warning" text v-else).pa-4
      p.title У вас не настроена почта
      p Вы можете настроить почту в своем профиле
      v-btn(
        color="primary"
        to="/profile"
      ) Перейти в профиль
    confirm-form-dialog(
      v-model="deleteQuestionsDialog"
      @accept="acceptDeleteQuestions"
      :message="`Действильно удалить ${selected.length} заявок?`"
    )
    event-form(
      :selected="selected"
      :value="dialogEventForm"
      @close="closeEventForm"
    )
</template>

<script>
import SelectProject from '@/components/inputs/SelectProject.vue';
import SelectMyUser from '@/components/inputs/SelectMyUser.vue';
import { CRUDQuestionCategory } from '@/services/API/_crud';
import emailSettingsService from '@/services/API/email-settings';
import { differenceInDays } from 'date-fns/esm';
import SmartTable from '@/components/SmartTable/index.vue';
import clientQuestionService from '@/services/API/client-questions';
import {
  CLIENT_QUESTION_STATUS,
  CLIENT_QUESTION_STATUS_TEXT,
} from '../constants';
import ConfirmFormDialog from '@/components/dialogs/ConfirmFormDialog.vue';
import mixinDateTime from '@/mixins/mixinDateTime';
import { mapActions, mapGetters } from 'vuex';
import { CACHE_KEYS } from '@/store/modules/cache';
import { NOTIFICATION_TYPES } from '@/store/modules/notification';
import EventForm from './GroupQuestion/components/GroupModalForm.vue';
// import searchService from '@/services/API/search';
import AppDropdown from '@/components/AppDropdown.vue';

export default {
  components: {
    SelectProject,
    SmartTable,
    EventForm,
    ConfirmFormDialog,
    AppDropdown,
    SelectMyUser,
  },
  mixins: [mixinDateTime],
  data() {
    return {
      tabList: [

        { text: 'Ожидающие', value: 1, count: null },
        { text: 'Принятые в работу', value: 2, count: null },
        { text: 'Отвеченные', value: 3, count: null },
        { text: 'Закрытые', value: 4, count: null },

        { text: 'Консультация', value: 6, count: null },
      ],
      dialogEventForm: false,
      loading: true,
      is_active: false,
      tab: 2,
      search: '',
      clientQuestions: [],
      selected: [],
      deleteQuestionsDialog: false,

      grouppedQuiestions: [],

      headers: [
        {
          text: '',
          value: 'view',
          maxWidth: '40px',
        },
        {
          text: 'Номер заявки',
          value: 'id',
          sortable: true,
          searchable: true,
          notVisibleIcon: true,
        },
        {
          text: 'Проект', value: 'project_id', sortable: true,  searchable: true,
        },
        {
          text: 'Принят',
          value: 'worker',
          searchable: true,
        },
        {
          text: 'Категория',
          value: 'question_category_name',
          searchable: true,
        },
        {
          text: 'Название проблемы',
          value: 'text',
          sortable: true,
          searchable: true,
        },
        {
          text: 'Дата заявки',
          value: 'created_at',
          sortable: true,
        },
        {
          text: 'Статус',
          sortable: true,
          value: 'status',
          searchable: true,
        },
        {
          text: 'Группа',
          searchable: true,
          value: 'groups',
        },
        // {
        //   text: 'Процесс выполнения',
        //   sortable: true,
        //   value: 'todo_lists_status',
        //   align:'center',
        // },
        {
          text: 'Почта отправителя',
          sortable: true,
          value: 'email',
          searchable: true,
        },
        { text: 'Муниципалитет', value: 'municipality_id', sortable: true },
        // { text: 'Роль пользователя', value: 'role',          sortable:true },
        // { text: 'Регион', value: 'region',          sortable:true },
        // { text: 'Тип проблемы', value: 'type_problem',          sortable:true },
      ],
      needToUpdateTable: false,
      updateTable: null,
      consultingType: 0,
      CLIENT_QUESTION_STATUS,
      CLIENT_QUESTION_STATUS_TEXT,
    };
  },
  computed: {
    ...mapGetters({
      cachedMunicipality: 'cache/cachedMunicipality',
      cachedCategory: 'cache/cachedCategory',
      cachedProject: 'cache/cachedProject',
      notification: 'notification/notification',
      user: 'auth/getUser',
      isSupport: 'auth/isSupport',
      isAdmin: 'auth/isAdmin',
    }),

    statusItems() {
      return Object.keys(CLIENT_QUESTION_STATUS_TEXT).map((key) => ({
        value: key,
        text: CLIENT_QUESTION_STATUS_TEXT[key],
      }));
    },
    consultingDropdownFilter() {
      return  [{ value: 1, name:'Входящие' }, { value: 0, name:'Исходящие' }];
    },
  },

  watch: {
    tab() {
      this.needToUpdateTable = true;
    },
    notification(v) {
      if (v.type === NOTIFICATION_TYPES.CLIENT_QUESTION) {
        this.updateTable((items) => [v.data, ...items]);
      }
    },

    // needToUpdateTable() {
    //   this.fetchGrouppedQuestions();
    // },

    consultingType() {
      this.needToUpdateTable = true;
    },
  },
  async created() {
    this.loading = true;
    await this.getUserIsActive();
    // await this.fetchGrouppedQuestions();
    await this.fetchQuestionCategory();
    this.loading = false;
  },

  methods: {
    ...mapActions({
      loadToCache: 'cache/loadToCache',
    }),

    async adapter({ _update, ...options }) {
      const params = {
        'per-page': options.itemsPerPage,
        'sort': 'id',
        'expand': 'todo_lists_status,current_transfer,groups,worker',
        'search[is_incoming]': this.tab === CLIENT_QUESTION_STATUS.AWAITING.toString() ? this.consultingType : null,
        ...options,
      };
      this.needToUpdateTable = false;
      this.updateTable = _update;

      //       if (this.consultingType !== 'undefined') {
      //   if (this.consultingType === 0) {
      //     params.transfer_worker_id = this.user.id;
      //   } else if (this.consultingType === 1) {
      //     params.transfer_owner_id = this.user.id;
      //   }
      // }

      if (this.tab) {
        params['search[status]'] = this.tab;
      }

      const response = await clientQuestionService.getAll(params);

      this.tabList.find((item) => item.value.toString() === this.tab).count = response.headers['x-pagination-total-count'];
      this.clientQuestions = response.data.data;
      const municipality_ids = response.data.data.map(
        ({ municipality_id }) => municipality_id,
      );
      await this.loadToCache({
        key: CACHE_KEYS.municipalities,
        ids: municipality_ids,
      });

      const project_ids = response.data.data.map(
        ({ project_id }) => project_id,
      );
      await this.loadToCache({ key: CACHE_KEYS.projects, ids: project_ids });

      return new Promise((resolve) => resolve(response));
    },
    checkStatus(eq, indexStatus) {
      let statuses = this.clientQuestions.filter(({ id }) => this.selected.indexOf(id));
      statuses = statuses.map(({ status }) => status);
      return eq ? statuses.every((val) => val === indexStatus) : statuses.every((val) => val !== indexStatus);
    },
    async groupClose() {
      try {
        const params = {
          'client_question_ids': this.selected,
        };
        await clientQuestionService.close(params);
        this.selected = [];
        this.needToUpdateTable = true;
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    // async fetchGrouppedQuestions() {
    //   try {
    //     const params = {
    //       'group_by': 'status',
    //     };
    //     const response = await searchService.clientQuestions(params);
    //     const res = [];
    //     response.data.data.forEach((val) => {
    //       res[val.key] = val.doc_count;
    //     });
    //     this.countQuestions = res;
    //   } catch (error) {
    //     this.$toast.error(error.response.data.result_message);
    //   }
    // },
    async fetchQuestionCategory() {
      try {
        const response = await CRUDQuestionCategory.getAll();
        const categoryIds = response.data.data.map(({ id }) => id);
        await this.loadToCache({ key:CACHE_KEYS.question_categories, ids: categoryIds });
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    getStatusCount(status) {
      return (
        this.grouppedQuiestions.find(({ key }) => key === status)?.doc_count
        || ''
      );
    },

    async acceptDeleteQuestions() {
      const params = {
        client_question_ids: this.selected,
      };
      await clientQuestionService.destroy(params);

      this.needToUpdateTable = true;
      this.deleteQuestionsDialog = false;
      this.selected = [];
    },

    checkIsOverdue(item) {
      if (
        item.status === CLIENT_QUESTION_STATUS.PENDING
        && differenceInDays(new Date(), new Date(item.created_at)) > 1
      ) {
        return { class: 'red lighten-4' };
      }

      return {};
    },
    // async getAllCount() {
    //   const result = [];
    //   for (let i = 1; i <= 6; i++) {
    //     const params = {
    //       'search[status]': i,
    //       'per-page': 1,
    //       'page': 1,
    //     };
    //     //  eslint-disable-next-line
    //     const response = await clientQuestionService.getAll(params);
    //     result.push(response.headers['x-pagination-total-count']);
    //   }
    //   await Promise.all(result);
    //   this.countQuestions = result;
    // },
    async getUserIsActive() {
      if (!this.user.email_setting) return;
      const { id } = this.user.email_setting;
      const response = await emailSettingsService.get(id);
      this.is_active = response.data.data.is_active || true;
    },
    async closeEventForm() {
      this.dialogEventForm = false;
      this.needToUpdateTable = true;
      this.selected = [];
    },
    statusColor(status) {
      return {
        [CLIENT_QUESTION_STATUS.PENDING]: 'error',
        [CLIENT_QUESTION_STATUS.ACCEPTED]: 'primary',
        [CLIENT_QUESTION_STATUS.ANSWERED]: 'success',
        [CLIENT_QUESTION_STATUS.CLOSED]: 'secondary',
        [CLIENT_QUESTION_STATUS.AWAITING]: 'accent',
      }[status];
    },

    isConsultating({ status, current_transfer }) {
      return (
        status === CLIENT_QUESTION_STATUS.AWAITING
        && current_transfer?.owner_id === this.user.id
      );
    },
  },
};
</script>

<style lang="scss">
.theme--light .v-data-table-header th {
  min-width: auto;
}
.v-dialog.v-dialog--active {
  overflow-y: visible;
}
.close {
  position: absolute;
  right: -20px;
  top: -15px;
}
.v-data-table__wrapper {
  table {
    th:nth-child(n + 3) {
      min-width: 200px;
    }
  }
}
.cell {
  &-error {
    color: #f84283;
    font-weight: bold;
  }
}
</style>
